import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { MatIconModule, MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { StoreService } from './services/store.service';

export const coreProviders: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  },
  {
    provide: MAT_ICON_DEFAULT_OPTIONS,
    useValue: { fontSet: 'material-icons-outlined' }
  },
  {
    provide: StoreService,
    useClass: StoreService
  }
];

export const coreImports = [
  MatNativeDateModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  OverlayModule,
  MatIconModule,
];
